import React from "react";
import { Star, CheckCircle2 } from "lucide-react";
import { REVIEWS } from "../mock";

const Reviews = () => {
  return (
    <section className="bg-[#FFF2EC]">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24">
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-1 mb-3">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className="w-4 h-4 fill-[#DD4D2A] text-[#DD4D2A]"
              />
            ))}
          </div>
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#1A1410]/60 font-semibold mb-3">
            Rated 4.8/5 based on 10,000+ Total Reviews
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-semibold text-[#1A1410]">
            Customer <span className="italic">Reviews</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-7">
          {REVIEWS.map((r) => (
            <article
              key={r.id}
              className="bg-[#FFE4D6] rounded-3xl overflow-hidden border border-[#1A1410]/8"
            >
              <div className="grid grid-cols-[140px_1fr] md:grid-cols-[180px_1fr]">
                <div className="relative aspect-[3/4] md:aspect-auto bg-[#FFD1BF]">
                  <img
                    src={r.photo}
                    alt={r.name}
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 md:p-6 flex flex-col">
                  <div className="flex items-center gap-2">
                    <span className="font-serif-display text-lg font-semibold">
                      {r.name},
                    </span>
                    <span className="text-sm text-[#1A1410]/60">{r.age}</span>
                  </div>
                  {r.verified && (
                    <div className="flex items-center gap-1 text-[11px] text-[#DD4D2A] font-semibold uppercase tracking-wider mt-0.5">
                      <CheckCircle2 className="w-3.5 h-3.5" />
                      Verified Buyer
                    </div>
                  )}
                  <div className="flex items-center gap-1 mt-2">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className="w-3.5 h-3.5 fill-[#DD4D2A] text-[#DD4D2A]"
                      />
                    ))}
                  </div>
                  <p className="mt-3 text-sm text-[#1A1410]/80 leading-relaxed line-clamp-5">
                    {r.body}
                  </p>
                  <div className="mt-4 pt-4 border-t border-[#1A1410]/10 flex items-center gap-3">
                    <img
                      src={r.productImage}
                      alt={r.product}
                      className="w-12 h-12 rounded-lg object-cover border border-[#1A1410]/10"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="text-xs font-semibold line-clamp-1">
                        {r.product}
                      </div>
                      <div className="flex items-baseline gap-1.5">
                        <span className="text-sm font-semibold">
                          ${r.price}.00
                        </span>
                        <span className="text-xs text-[#1A1410]/40 line-through">
                          ${r.compareAt}.00
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 text-[11px] text-[#1A1410]/50 uppercase tracking-wider">
                    {r.date}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
